/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_Never_Item_4Inputs */

const es_privacy_policy_usage_never_item_4 = /** @type {(inputs: Privacy_Policy_Usage_Never_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenar modelos de IA compartidos con sus datos especificos`)
};

const en_privacy_policy_usage_never_item_4 = /** @type {(inputs: Privacy_Policy_Usage_Never_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training shared AI models with your specific data`)
};

/**
* | output |
* | --- |
* | "Training shared AI models with your specific data" |
*
* @param {Privacy_Policy_Usage_Never_Item_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_never_item_4 = /** @type {((inputs?: Privacy_Policy_Usage_Never_Item_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_Never_Item_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_never_item_4(inputs)
	return en_privacy_policy_usage_never_item_4(inputs)
});
export { privacy_policy_usage_never_item_4 as "privacy_policy.usage.never_item_4" }